"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentPlaybackPosition = getCurrentPlaybackPosition;
exports.resumePlayback = resumePlayback;
exports.setMediaSessionActions = setMediaSessionActions;
var _moment = _interopRequireDefault(require("moment"));
/**
 * Calculates the elapsed time since the media started playing.
 *
 * @param {boolean} isPlaying - Indicates whether the media is currently playing.
 * @param {number} startedOn - The Unix timestamp when the media started playing.
 * @param {number} seek - The current seek position in the media.
 * @param {number} serverTime - The current server time as a Unix timestamp.
 * @param {number} [serverTimeDelta] - The difference between the client and server times in seconds.
 * @returns {number} The elapsed time since the media started playing, adjusted for seek and server time differences.
 */
function getTimeElapsed(isPlaying, startedOn, seek, serverTime, serverTimeDelta) {
  // If media is paused, elapsed will be equal to seek. In this scenario
  // startedOn is undefined and irrelevant
  if (!isPlaying) return seek;
  var diff;
  if (serverTimeDelta !== undefined) {
    // NEW - we use serverTimeDelta to calculate serverTime
    var calculatedServerTime = (0, _moment["default"])().utc().unix() - serverTimeDelta;
    diff = calculatedServerTime - startedOn;
  } else {
    // LEGACY - we have serverTime
    diff = serverTime - startedOn;
  }
  return (diff < 0 ? 0 : diff) + seek;
}

/**
 * Returns the current playback position of the media element.
 *
 * @param {boolean} isPlaying - Indicates whether the media is currently playing.
 * @param {number} startedOn - The Unix timestamp when the media started playing.
 * @param {number} seek - The current seek position in the media.
 * @param {number} duration - The duration of the media in seconds.
 * @param {number} serverTime - The current server time as a Unix timestamp.
 * @param {number} [serverTimeDelta] - The difference between the client and server times in seconds.
 * @param {boolean} loop - Indicates whether the media should loop.
 */
function getCurrentPlaybackPosition(isPlaying, startedOn, seek, duration, serverTime, serverTimeDelta, loop) {
  // calculate a proper `currentTime` attribute to set for the playerRef
  if (duration) {
    //The time since the video started playing
    var timeElapsed = getTimeElapsed(isPlaying, startedOn, seek, serverTime, serverTimeDelta);
    var desiredCurrentTime;
    if (timeElapsed <= duration) {
      desiredCurrentTime = timeElapsed;
    } else if (timeElapsed > duration && !loop) {
      console.log("getCurrentPlaybackPosition(): timeElapsed is greater than duration, setting currentTime to duration");
      desiredCurrentTime = duration;
    } else {
      console.log("getCurrentPlaybackPosition(): timeElapsed is greater than duration, using modulo to loop the desiredCurrentTime");
      // take into account any loops
      desiredCurrentTime = timeElapsed % duration;
    }
    if (isNaN(desiredCurrentTime)) return;
    console.log("getCurrentPlaybackPosition(): currentTime set to ".concat(desiredCurrentTime));
    return desiredCurrentTime;
  }
}

/**
 * Resumes playback of the video if it is paused and meets the specified conditions.
 *
 * @param {Object} player - The Video.js player instance.
 * @param {number} duration - The total duration of the video in seconds.
 * @param {boolean} loop - Indicates whether the video should loop when it reaches the end.
 * @returns {void}
 */
function resumePlayback(player, duration, loop) {
  // video is "over" and has run out already, and should not play
  if (!loop && player.currentTime() === duration) {
    return;
  }
  var playPromise = player.play();
  if (playPromise !== undefined) {
    playPromise["catch"](function (error) {
      console.log('Failed to resume video playback ', error);
    });
  }
}

/*
 * Updates the Media Session API action handlers
 */
function setMediaSessionActions(handler) {
  if ('mediaSession' in navigator) {
    var actions = ['play', 'pause', 'seekbackward', 'seekforward', 'seekto', 'stop'];
    for (var _i = 0, _actions = actions; _i < _actions.length; _i++) {
      var action = _actions[_i];
      try {
        navigator.mediaSession.setActionHandler(action, handler);
      } catch (e) {
        console.error("Failed to update ".concat(action, " action of media session : "), e);
      }
    }
  }
}